import React from 'react'
import { Link } from 'react-router-dom'
import featuresimg from '../../images/features/img-1.png'
import featuresimg3 from '../../images/features/img-3.png'
import './style.css'

const Features = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div className="features-area">
            <div className="container">
                {/* Vision Section */}
                <div className="row align-items-center" style={{marginBottom: '60px'}}>
                    <div className="col-lg-6">
                        <div className="features-text">
                            <div className="section-title">
                                <div className="thumb-text">
                                    <span>OUR VISION</span>
                                </div>
                            </div>
                            <h2>A Leading Performing Arts Ecosystem that Combines Tradition with Science</h2>
                            <p>
                                We envision becoming a pioneering force in performing arts education, where ancient traditions meet modern innovation. With investor support, we are expanding our reach through training hubs, digital learning modules, certified programs, and institutional collaborations. This approach creates measurable social impact while delivering sustainable returns.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="features-wrap">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-8 col-sm-10 col-12">
                                    <div className="features-item">
                                        <div className="features-icon">
                                            <img draggable="false" src={featuresimg} alt="" />
                                        </div>
                                        <div className="features-content">
                                            <h2>
                                                <Link onClick={ClickHandler} to="/programs/children">
                                                    Children's Performing Arts
                                                </Link>
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mission Section */}
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="features-text">
                            <div className="section-title">
                                <div className="thumb-text">
                                    <span>OUR MISSION</span>
                                </div>
                            </div>
                            <h2>Empowering Underprivileged Children Through Performing Arts</h2>
                            <p>
                                At <strong>Nardhanamala Centre for Performing Arts Foundation</strong>, we are dedicated to empowering underprivileged children through quality performing arts training. By providing access to exceptional programs, we foster discipline, creativity, and confidence—essential tools that positively shape their future and transform communities.
                            </p>
                            <Link to="/donate" className="theme-btn">
                                Support Our Mission <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                            </Link>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="features-wrap">
                            <div className="row justify-content-center">
                                <div className="col-lg-8 col-md-8 col-sm-10 col-12">
                                    <div className="features-item-2 active">
                                        <div className="features-icon">
                                            <img draggable="false" src={featuresimg3} alt="" />
                                        </div>
                                        <div className="features-content">
                                            <h2>
                                                <Link onClick={ClickHandler} to="/programs/seniors">
                                                    Dance for Joy (50+)
                                                </Link>
                                            </h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Features